import { asMultiStyleConfig } from '../../../../utils/theme';
import { transparentize } from '../../../../utils/color';
export var WarningBanner = asMultiStyleConfig({
  parts: ['alert', 'body', 'title', 'subtitle', 'message', 'warningBody', 'warning'],
  baseStyle: {
    alert: {
      w: '100%',
      p: [6, 8],
      borderRadius: 'none',
      backgroundColor: 'yellow.100'
    },
    body: {
      mx: 'auto',
      textAlign: 'center',
      borderColor: 'none'
    },
    title: {
      fontSize: ['lg', 'xl'],
      fontWeight: 'bold'
    },
    subtitle: {
      fontSize: ['md', 'lg'],
      fontWeight: 'bold'
    },
    message: {
      fontSize: ['sm', 'md']
    },
    warningBody: {
      p: 6,
      mb: [-6, -8],
      mx: [-6, -8],
      mt: 6,
      bg: transparentize('#EBF7FF', 0.1)
    },
    warning: {
      fontSize: ['sm', 'md'],
      mx: 'auto',
      fontWeight: 600
    }
  }
});